<style lang="stylus">
    .AddSymbolFromLocal-mask
        modal-mask()
        .AddSymbolFromLocal-modal
            width 410px
            height 220px
            .AddSymbolFromLocal-container
                padding 15px 20px
                .AddSymbolFromLocal-line
                    display flex
                    justify-content space-around
                    margin-bottom 10px
                    .input-box
                        width 260px
                    >p
                        line-height 24px
                        width 85px
                        text-align right
                .AddSymbolFromLocal-import
                    display flex
                    justify-content space-around
                    margin-bottom 10px
                    .import-showTitle
                        line-height 24px
                        width 85px
                        text-align right
                    .import-showText
                        width 176px
                        height 24px
                        line-height 24px
                        text-indent 10px
                        border 1px solid var(--border-color-library-modal-btn)
                        border-radius 3px
                        overflow hidden
                    .import-btn
                        width 71px
                        height 24px
                        border 1px solid var(--border-color-library-modal-btn)
                        border-radius 3px
                        text-align center
                        line-height 24px
                        font-size 12px
                        cursor pointer
                        user-select none
                        &:hover
                            background-color var(--bg-color-library-btn-import-hover)
                    input
                        display none
</style>

<template>
    <div class="AddSymbolFromLocal-mask">
        <Dialog class="AddSymbolFromLocal-modal" :title="$t('title')" :isShow="true" @close="closeModal">
            <div class="AddSymbolFromLocal-container">
                <div class="AddSymbolFromLocal-line">
                    <p>{{ $t("name") }}:</p>
                    <Input class="input-box" v-model="symbolName" size="small" />
                </div>

                <div class="AddSymbolFromLocal-import">
                    <p class="import-showTitle">{{ $t("imgfile") }}:</p>
                    <div ref="imgText" class="import-showText"></div>
                    <div class="import-btn" @click="importBtn('img')">{{ $t("importBtn") }}</div>
                    <input ref="imgImporter" type="file" accept=".jpg,.png,.jpeg" @change="getImg($event)" />
                </div>
                <div class="AddSymbolFromLocal-import">
                    <p class="import-showTitle">{{ $t("edefile") }}:</p>
                    <div ref="edeText" class="import-showText"></div>
                    <div class="import-btn" @click="importBtn('ede')">{{ $t("importBtn") }}</div>
                    <input ref="edeImporter" type="file" accept=".ede" @change="getEde($event)" />
                </div>
            </div>

            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import Dialog from "../Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class AddSymbolFromLocal extends Vue {
        @Inject()
        ["showMessage"];
        symbolName: string = "";
        imgFile: any;
        edeFile: any;
        userWorkerURL: string = appConfig.userWorkerURL;
        worker: any;
        importBtn(type) {
            let img = this.$refs.imgImporter as HTMLInputElement;
            let ede = this.$refs.edeImporter as HTMLInputElement;
            (type == "img" && (img.click(), true)) || ede.click();
        }
        getImg(e) {
            let img = this.$refs.imgText as HTMLElement;
            img.innerHTML = e.target.files[0].name;
            this.imgFile = e.target.files[0];
            e.target.value = null;
        }
        getEde(e) {
            let ede = this.$refs.edeText as HTMLElement;
            ede.innerHTML = e.target.files[0].name;
            this.edeFile = e.target.files[0];
            e.target.value = null;
        }
        reflashLibrary() {
            // 通知library刷新列表
            let dbName = this.dbAndTable[0];
            let tableName = this.dbAndTable[1];
            let tableID = this.dbAndTable[2];
            let ts: any = this;
            ts.$bus.$emit("setLibrary", {
                type: "updateLibrary",
                groupName: dbName,
                tableID: tableID,
            });
        }
        dataURLtoBlob(dataurl) {
            var arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        }
        addSymbolToDB() {
            let promistList = [];
            let dbName = this.dbAndTable[0];
            let tableName = this.dbAndTable[1];
            let tableID = this.dbAndTable[2];

            let dbObj = {
                name: this.symbolName,
            };
            let userInfo = this.$store.state.user.userInfo;
            // ede
            let reader = new FileReader();
            reader.readAsText(this.edeFile);
            let promise = new Promise((resolve, reject) => {
                reader.onload = (e) => {
                    let dataArr = (<any>e.target).result.match(/\<\!\-\-([\s\S]*?)\-\-\>/g);
                    dbObj["data"] = dataArr[0].replace(/(<!--)|(-->)/g, "");
                    dbObj["parent"] = tableName;
                    resolve();
                };
            });
            // img file to blob
            promistList.push(promise);
            let reader2 = new FileReader();
            reader2.readAsDataURL(this.imgFile);
            let promise2 = new Promise((resolve, reject) => {
                reader2.onload = (e) => {
                    let blob = this.dataURLtoBlob((e.target as FileReader).result);
                    dbObj["blob"] = blob;
                    resolve();
                };
            });
            promistList.push(promise2);
            Promise.all(promistList).then(() => {
                let userInfo = this.$store.state.user.userInfo;
                let updateData = {
                    DBName: this.dbAndTable[0],
                    tableName: this.dbAndTable[1],
                    tableID: this.dbAndTable[2],
                    nowItem: this.libClickObj.nowItem,
                    updateType: "addSymbol",
                    dbObj: dbObj,
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                };

                this.worker = new Worker(this.userWorkerURL);
                this.worker.postMessage({
                    type: "update",
                    urls: this.urls,
                    data: updateData,
                });
                let ossList = this.$store.state.library.ossList;
                this.worker.onmessage = (e) => {
                    let message = e.data;
                    if (message.type === "updateOK") {
                        let ts: any = this;
                        this.reflashLibrary();
                        ts.$bus.$asyncEmit("uploadToCloud", { message }).then((e: any) => {
                            let version = e.data.version;
                            this.worker.postMessage({
                                type: "setVersion",
                                urls: this.urls,
                                data: {
                                    versionDB: `myDBVersion_${userInfo.user_id}`,
                                    tableID: this.dbAndTable[2],
                                    version,
                                    params: {
                                        updateModified: true,
                                    },
                                },
                            });
                        });
                    } else if (message.type === "setVersionOK") {
                        this.worker.terminate();
                    }
                };
            });
        }
        confirm() {
            this.closeModal();
            if (this.symbolName == "") {
                this.showMessage({
                    type: 2,
                    imgType: 2,
                    time: 1,
                    content: this.$t("nullName"),
                });
                return;
            }
            this.addSymbolToDB();
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        mounted() {}

        created() {}
        get dbAndTable() {
            return this.$store.state.ui.selectLibrary;
        }
        get libClickObj() {
            return this.$store.state.ui.libClickObj;
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "从本地导入库",
    "name": "符号名称",
    "imgfile": "图片文件",
    "edefile": "ede文件",
    "importBtn": "浏览",
    "confirm": "确定",
    "cancel": "取消",
    "nullName": "名称不可为空"
  },
  "en": {
    "title": "Import Library from Computer",
    "name": "Symbol Name",
    "imgfile": "Image File",
    "edefile": "*.ede File",
    "importBtn": "Browse",
    "confirm": "OK",
    "cancel": "Cancel",
    "nullName": "Name cannot be empty."
  },
  "fr": {
    "title": "Importer la Bibliothèque du Local",
    "name": "Nom Symbolique",
    "imgfile": "Fichier Image",
    "edefile": "Fichier ede",
    "importBtn": "Parcourir",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "nullName": "Nom ne peut pas être vide"
  },
  "de": {
    "title": "Bibliothek vom Computer importieren",
    "name": "Symbolname",
    "imgfile": "Bilddatei",
    "edefile": "*.ede File",
    "importBtn": "Browsen",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "nullName": "Name darf nicht leer sein"
  },
  "jp": {
    "title": "ローカルからライブラリをインポート",
    "name": "図形名",
    "imgfile": "画像ファイル",
    "edefile": "edeファイル",
    "importBtn": "参照",
    "confirm": "OK",
    "cancel": "キャンセル",
    "nullName": "名前は空にできません"
  },
  "es": {
    "title": "Importar la biblioteca de la computadora",
    "name": "Nombre del símbolo",
    "imgfile": "Archivo de imagen",
    "edefile": "Archivo *.ede",
    "importBtn": "Examinar",
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "nullName": "El nombre no puede estar vacío"
  },
  "pt": {
    "title": "Importar Biblioteca de Computador",
    "name": "Nome de Símbolo",
    "imgfile": "Ficheiro de Imagem",
    "edefile": "Ficheiro *.ede",
    "importBtn": "Navegar",
    "confirm": "OK",
    "cancel": "Cancelar",
    "nullName": "Nome não pode estar vazio."
  },
  "it": {
    "title": "Importa Libreria da Computer",
    "name": "Nome Simbolo",
    "imgfile": "File Immagine",
    "edefile": "File *.ede",
    "importBtn": "Sfoglia",
    "confirm": "OK",
    "cancel": "Annulla",
    "nullName": "Si prega di riempire il campo del nome."
  },
  "tw": {
    "title": "從本地導入庫",
    "name": "符號名稱",
    "imgfile": "圖片檔案",
    "edefile": "ede檔案",
    "importBtn": "瀏覽",
    "confirm": "確定",
    "cancel": "取消",
    "nullName": "名稱不可為空"
  },
  "kr": {
    "title": "페이지에서 라이브러리 가져오기",
    "name": "심볼 이름 ",
    "imgfile": "이미지 파일",
    "edefile": "ede 파일",
    "importBtn": "브라우즈",
    "confirm": "확인 ",
    "cancel": "취소",
    "nullName": "이름은 비워 둘 수 없습니다."
  }
}
</i18n>
